// extracted by mini-css-extract-plugin
export default {"optimiseinfo":"OptimiseInfo_optimiseinfo__f5OtT","info_1":"OptimiseInfo_info_1__82HGp","info_2":"OptimiseInfo_info_2__RpYef"};